<div class="modal-header">
    Campi personalizzati
    <div class="card-tools">
      <button type="button" class="btn btn-tool" (click)="confirm()" >
        <i class="fas fa-times"></i>
      </button>
    </div>
</div>
<div class="modal-body">
    <br>
    <p *ngIf="list.length==0" class="text-center text-muted">
        Nessun campo personalizzato disponibile!
    </p>
    <div class="mb-3" *ngIf="list.length>0">
        <button class="btn btn-sm btn-default border mr-1" (click)="checkAll(true)">Tutti</button>
        <button class="btn btn-sm btn-default border mr-1" (click)="checkAll(false)">Nessuno</button>
    </div>    
    <p *ngFor="let c of list">
        <input class="mr-2" type="checkbox" [(ngModel)]="c.selected"/>
        <i>{{c.label}}</i>
    </p>    
</div>
<div class="modal-footer text-center">    
    <button class="btn btn-default btn-block" (click)="confirm()">Ok</button>
</div>